const MEDIAPIPE_TASKS_VISION_VERSION = "0.10.14"

export const MEDIAPIPE_TASKS_VISION_BASE = `https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@${MEDIAPIPE_TASKS_VISION_VERSION}/wasm`

export const MEDIAPIPE_SELFIE_SEGMENTER_LANDSCAPE_URL =
  "https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter_landscape/float16/latest/selfie_segmenter_landscape.tflite"
